module.exports = "/src/views/eternal-dev/businesses/gas-station/images/dark/GlobeOil/header-background.svg";